import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { ErrorHandler, inject, NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GlobalErrorHandlerService } from './error-handler';
import { SharedModule } from './shared/shared.module';

@NgModule({
	declarations: [AppComponent],
	imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, CoreModule, SharedModule],
	bootstrap: [AppComponent],
	providers: [
		// This reverts a change Angular made in 21 that is causing odd interactions with dialog and selects
		{ provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
		{ provide: ErrorHandler, useClass: GlobalErrorHandlerService },
		provideCharts(withDefaultRegisterables()),
		provideEnvironmentNgxMask(),
	],
})
export class AppModule {
	constructor() {
		inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-outlined');
	}
}
